// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"caa69c92","278":"416da333","359":"7ff7649f","896":"ea8c2d3a"}[chunkId] + ".chunk.css";
};